/* eslint-disable @next/next/no-img-element */
import React, { useContext } from 'react';
import { CARD_BUTTON_IMG } from '../../../config/constants/images';
import {
  CARD_BUTTON_TEXT,
  CARD_BUTTON_IMG_TEXT,
} from '../../../config/text/text';
import ThemeContext from '../../../providers/ThemeProvider';

const CardButton = () => {
  const theme = useContext(ThemeContext);

  return (
    <>
      <div className="card">
        <img
          alt={CARD_BUTTON_IMG_TEXT}
          className="card__img"
          src={CARD_BUTTON_IMG}
        />
      </div>
      <span className="sr-only">{CARD_BUTTON_TEXT}</span>
      <style jsx>{`
        .card {
          text-align: center;
          font-size: 0;
        }
        .card__img {
          width: 50%;
          margin: 5%;
        }
        .card__text {
          font-size: 1vw;
          line-height: 1vw;
          color: $black;
          margin: 0;
          padding-top: 5%;
          text-transform: ${theme.text.cta.button};
          white-space: normal;
        }
        @media (max-width: ${theme.breakpoints.lgDown}) {
          .card__img {
            width: 55%;
          }
        }
      `}</style>
    </>
  );
};

export default CardButton;
